import { useCallback } from 'react'

import { api } from 'app/api'
import { POST_REPORT_CANCEL, convertParams, convertResult } from 'app/common/api/requests/reports/cancel/post'


export function useReportCancel(reportID: string | null) {
  const cancel = useCallback(async () => {
    if (!reportID) return null
    const res = await api.request(POST_REPORT_CANCEL, {
      error: 'Не удалось отменить генерацию отчета',
      params: { reportID },
      convertions: {
        convertParams,
        convertResult,
      },
    })
    return res
  }, [reportID])

  return cancel
}
